module.exports = __webpack_public_path__ + "img/電気回路_1_2_4.8db9ff58.png";